import { createSlice } from "@reduxjs/toolkit";

const createDiscussionSlice = createSlice({
  name: "modal",
  initialState: {
    openModal: false,
  },
  reducers: {
    disableModal(state) {
      state.openModal = false;
    },
    enebleModal(state) {
      state.openModal = true;
    },
  },
});

export const createDiscussionSliceActions = createDiscussionSlice.actions;

export default createDiscussionSlice.reducer;
